export function FrozenTableElements(firstColumn) {
	'use strict';

	this.header = 'table-header';
	this.frozenHeader = 'table-frozen-header';
	this.frozenColumn = 'table-frozen-column';
	this.innerColumn = 'inner-column';

	var SCROLL_HEIGHT = 18;

	this.initFrozenElements = function() {
		if (firstColumn)
			this.initFrozenFirstColumn();
		this.initFrozenHeader();
		this.bindTableScrolling();
	};

	this.initFrozenHeader = function() {
		$('#' + this.frozenHeader).remove();
		$('#table thead').attr('id', this.header);
		$('#' + this.header)[0].classList.remove('hidden-header');
		var frozenHeader = $('#' + this.header).clone(true, true);
		frozenHeader.attr('id', this.frozenHeader);
		$('#' + this.header)[0].classList.add('hidden-header');
		// frozenHeader.css('top', parseInt($('.fixed-table-container').offset().top, 10) + 'px');
		frozenHeader.css('top', '-1px');
		frozenHeader.css('left', -$('.fixed-table-body')[0].scrollLeft + 'px');
		frozenHeader.css('position', 'absolute');
		frozenHeader.css('padding-left', '0px');
		$('#table').children().eq(0).before(frozenHeader[0].outerHTML);
		// var marginLeft = firstColumn ? '-1px' : '0px';
		// $('#' + this.frozenHeader).css('margin-left', marginLeft);
		this.setFrozenHeaderCellsWidth();
		this.setTooltipHeaderCells();
		var headerHeight = $('#table-frozen-header').outerHeight() - 1;
		$('.fixed-table-body').css('padding-top', headerHeight + 'px');
		// $('.fixed-table-body').css('max-height', '700px');
		$('.fixed-table-body').css('min-height', '300px');
	};

	this.initFrozenFirstColumn = function() {
		var frozenElements = this;
		$('#' + this.frozenColumn).remove();
		$('#table').children().first().before("<div id='table-frozen-column'><div id='inner-column'></div></div>");

		$('#' + this.frozenColumn).css('height', $('.fixed-table-container').height() + 'px');
		// $('#' + this.frozenColumn).css('top', ($('.fixed-table-container').offset().top) + 'px');
		$('#' + this.frozenColumn).css('top', '-1px');
		// $('#' + this.innerColumn).css('height', '700px');
		$('#' + this.innerColumn).css('top', '0px');

		$('#table').find('.bs-checkbox').each(function(index) {
			if (index == 0)
				$('#' + frozenElements.frozenColumn).append($(this).clone(true, true));
			else {
				if (!$(this).is('th')) {
					$(this).appendTo($('#' + frozenElements.innerColumn)).wrap("<tr></tr>");
				}
			}
		});
		$('.fixed-table-container').css('margin-left', '23px');
		this.setFrozenColumnCellsHeight();
	};

	this.setFrozenHeaderCellsWidth = function() {
		var frozenElements = this;
		$('#' + this.header).find('th').each(function(index) {
			if (index == 0) {
				if (!firstColumn)
					$('#' + frozenElements.frozenHeader + ' tr').children().eq(index).children().first().css('width', this.firstChild.getBoundingClientRect().width + 'px');
			} else {
				$('#' + frozenElements.frozenHeader + ' tr').children().eq(index).children().first().css('width', this.firstChild.getBoundingClientRect().width + 'px');
			}
		});
	};

	this.setTooltipHeaderCells = function () {
		var frozenElements = this,
			frozenHeader = $('#' + frozenElements.frozenHeader + ' th');

		frozenHeader.hover(function () {
			$(this).tooltip({
				placement: 'top',
				container: 'body',
				trigger: 'hover',
				title: $(this).find('div').text()
			});
			$(this).tooltip('toggle');
		});

		if (table.contextMenu) {
			$(table.contextMenu + '_context tr > td').hover(function (e) {
				var text = $(this).find('div').text();
				var lengthText = text.length;
				if (lengthText > 20) {
					$(this).tooltip({
						placement: (e.screenY < 230) ? 'bottom' : 'top',
						container: 'body',
						trigger: 'hover',
						title: $(this).find('div').text()
					});
					$(this).tooltip('toggle');
				}
			});
		}
	};

	this.setFrozenColumnCellsHeight = function() {
		var checkboxes = $('#inner-column .bs-checkbox');
		checkboxes.height(($('tbody').height()) / checkboxes.length);
	};

	this.bindTableScrolling = function() {
		var frozenElements = this;
		$('.fixed-table-body').scroll(function(e) {
			$('#' + frozenElements.frozenHeader).css('left', (-e.currentTarget.scrollLeft) + 'px');
			$('#' + frozenElements.innerColumn).css('top', (-e.currentTarget.scrollTop) + 'px');
		});

		$(window).scroll(function (e) {
			var tableFrozen = $('#table-frozen-header');
			var fixedTableBody = $('.fixed-table-body');
			var tableFrozenColumn = $('#table-frozen-column');
			var bsCheckbox = $('th.bs-checkbox');
			var innerColumn = $('#inner-column');
			var topHeigth = fixedTableBody.offset().top - $(this).scrollTop();
			if (topHeigth <= 5) {
				fixedTableBody.css('padding-top', '31px');
				tableFrozenColumn.css('top', '21px');
				tableFrozen.css('padding-left', '39px');
				tableFrozen.css('left', (-e.currentTarget.scrollLeft) + 'px');
				tableFrozen.css('position', 'fixed');
				bsCheckbox.css('position', 'fixed');
				bsCheckbox.css('top', '-1px');
				innerColumn.css('margin-top', '11px');
			} else {
				fixedTableBody.css('padding-top', '36px');
				tableFrozenColumn.css('top', '-1px');
				tableFrozen.css('position', 'absolute');
				tableFrozen.css('padding-left', '0px');
				bsCheckbox.css('position', 'relative');
				innerColumn.css('margin-top', '37px');
			}
		})
	};
}
